import React, { FC, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Button, Typography } from '@mui/material';
import { Role_Enum } from 'generated/graphql';
import { Layout } from 'components/layout';
import { useAuthContext } from 'components/authorization/AuthProvider';
import { AuthDisplayState } from 'components/authorizationPopups';

import linesImage from './Lines.svg';
import logoImage from './LandingPageHeader.svg';

const title = 'Vansanity';

type Props = Record<string, never>;

const Home: FC<Props> = () => {
  const { authUserPromise } = useAuthContext();
  const [authModalDisplay, setAuthModalDisplay] = useState(
    AuthDisplayState.Disabled,
  );

  const [userRole, setUserRole] = useState<Role_Enum | 'NoUser'>();
  const [userName, setUserName] = useState<string>('');

  useEffect(() => {
    authUserPromise()
      .then((user) => {
        setUserRole(user.role);
        setUserName(user.firstName);
      })
      .catch(() => {
        setUserRole('NoUser');
      });
  }, [authUserPromise]);

  if (!userRole) {
    // Still waiting to see what Role we are, if any so no display
    return <div />;
  } else if (userRole == Role_Enum.Provider) {
    // Providers are not allowed
    return (
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{ height: '60vh' }}
      >
        <Grid item>
          <Typography variant="h6">Please use the CloudMedSpas app.</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            This web portal is for administrators only.
          </Typography>
        </Grid>
      </Grid>
    );
  }

  // Admin/manager so can see the real Home

  return (
    <Layout
      authModalDisplay={authModalDisplay}
      setAuthModalDisplay={setAuthModalDisplay}
    >
      <Helmet
        htmlAttributes={{
          lang: 'EN',
        }}
        title={title}
        titleTemplate={title}
      ></Helmet>
      <Grid
        container
        direction="column"
        spacing={1}
        justifyContent="center"
        alignItems="center"
        sx={{ height: '80vh' }}
      >
        <Grid item>
          <img src={logoImage} />
        </Grid>
        <Grid item>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: '20px',
              lineHeight: '20.32px',
              textAlign: 'center',
              marginBottom: 3,
            }}
          >
            {userRole === 'NoUser'
              ? 'Please login to proceed to the admin panel'
              : `Welcome, ${userName}`}
          </Typography>
        </Grid>
        <Grid item>
          {userRole === 'NoUser' && (
            <Button
              variant="contained"
              onClick={() => setAuthModalDisplay(AuthDisplayState.SignIn)}
              sx={{
                backgroundColor: '#4B66F1',
                color: 'white',
                width: 219,
                height: 57,
                textTransform: 'capitalize',
                fontWeight: 800,
                fontSize: '16px',
                lineHeight: '19px',
                borderRadius: '13px',
                ':hover': {
                  backgroundColor: '#3655F5',
                  color: 'white',
                },
              }}
            >
              Login
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundColor: '#F3F4F5',
          background:
            'linear-gradient(90deg,rgba(250, 197, 127, 0.1) 0%,rgba(174, 227, 243, 0.4) 100%)',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: 'hidden',
          zIndex: -1,
        }}
      >
        <Grid item>
          <img src={linesImage} />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default Home;
